import { render, staticRenderFns } from "./partnerships.vue?vue&type=template&id=096fdb90&scoped=true&"
import script from "./partnerships.vue?vue&type=script&lang=js&"
export * from "./partnerships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096fdb90",
  null
  
)

export default component.exports